<template>
  <div class="com-item">
    <div class="w" id="wallet">
      <!-- PSC钱包 -->
      <div class="wl-title3">
        {{ $t("use.walletBox3T") }}
      </div>
      <div class="ul">
        <div
          class="wl-item2"
          v-for="(item, index) in $t('use.walletBox3List')"
          :key="index"
        >
          <div class="img">
            <img
              :src="
                require(`../../assets/images/v4/use/walletBox3${index + 1}.png`)
              "
              alt=""
            />
          </div>
          <div class="t">{{ item.title }}</div>
          <div class="link"></div>

          <div class="android">{{ item.subTitle }}</div>
          <div class="p">
            {{ item.text }}
          </div>
          <div class="more">
            <a
              href="javascript:;"
              @click="uti.goPath(store.link.use.walletBox2[index])"
            >
              {{ item.ft }}
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-arrowRight"></use>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Store from "../../store";
export default {
  data() {
    return {
      uti: Store.uti,
      store: Store.state,
    };
  },
};
</script>

<style lang="less" scoped>
.com-item {
  // height: 854px;
  padding-top: 146px;
  // padding-bottom: 100px;
  margin-bottom: 250px;
  box-sizing: border-box;
  background-image: url("../../assets/images/v4/home/box8Bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  // background-position: right 450px;
  .w {
    // background-color: pink;
    // height: 854px;
    .ul {
      margin-top: 100px;
      // background-color: pink;
      width: 100%;
      // height: 500px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .wl-item2 {
        width: 330px;
        height: 443px;
        padding: 15px 30px;
        .t {
          margin-top: 10px;
        }
        .link {
          margin-bottom: 5px;
        }
        .android {
          font-size: 14px;
          margin-top: 5px;
          font-weight: 400;
          color: #cccccc;
        }
        .p {
          margin-top: 10px;
          line-height: 25px;
        }
      }
      .wl-item2:hover {
        background: #015eea;
        // background: linear-gradient(-45deg, #015eea, #00c0fa);
        color: #ffffff;
        margin-top: -62px;
        .t {
          color: #ffffff;
        }
        .link {
          background-color: #fff;
        }
        .android {
          color: #ffffff;
        }
        .p {
          color: #ffffff;
        }
        .more {
          color: #ffffff;
          a {
            color: #ffffff;
          }
        }
      }

      .wl-item2:hover::after {
        margin-top: 62px;
      }
    }
  }
}
</style>
